import * as React from 'react'
import { MdClose } from 'react-icons/md'
import './styles.scss'

interface Props {
  onClose?: () => void
  title: React.ReactNode
}

export function ModalHeader({ onClose, title }: Props) {
  const closeContainer = () => {
    return (
      <div className="modal-header-close" onClick={onClose}>
        <MdClose size={18} />
      </div>
    )
  }

  return (
    <div className="modal-header">
      {/* {!!onClose && backContainer()} -- VIEW IN MOBILE */}
      <span className="modal-header-title">{title}</span>
      {!!onClose && closeContainer()}
    </div>
  )
}